/**
 * The narrow slice of Supabase the sync engine needs, as an interface so
 * tests can use a fake and so the engine never depends on supabase-js types.
 */
import type { SyncTable } from '../types';

export interface RemoteRow {
  id: string;
  team_id: string;
  updated_at: string;
  deleted_at: string | null;
  [k: string]: unknown;
}

export class RemoteError extends Error {
  constructor(
    message: string,
    public readonly kind: 'network' | 'auth' | 'rejected' | 'other',
    public readonly code?: string,
  ) {
    super(message);
  }
}

export interface RemoteApi {
  /** Upsert on id. Must throw RemoteError('rejected') on RLS/conflict (42501/23505), 'auth' on 401. */
  upsert(table: SyncTable, rows: Record<string, unknown>[]): Promise<RemoteRow[]>;
  /** Set deleted_at = now (soft delete). Ids the server doesn't know are ignored. */
  softDelete(table: SyncTable, ids: string[]): Promise<void>;
  /** Clear deleted_at. */
  restore(table: SyncTable, ids: string[]): Promise<void>;
  /** Rows with updated_at > since, soft-deleted included, ordered by updated_at. */
  pull(table: SyncTable, teamId: string, since: string | null): Promise<{ rows: RemoteRow[]; serverNow: string }>;
}
